import { useState, useEffect } from 'react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Combobox } from '@headlessui/react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Dropdown({ profiles, onChange, initialSmileName, showShop = false, searchSocialId = false }) {

  const [query, setQuery] = useState('')
  const [selectedRecord, setSelectedRecord] = useState({})
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [debouncedOnChange, setDebouncedOnChange] = useState(null)

  useEffect(() => {
    if (initialSmileName === undefined) return
    setSelectedRecord({ smileName: initialSmileName || '' })
  }, [initialSmileName])

  const generateRecordDisplayString = (record) => {
    const contact = record['contact'] ? `${record['contact']}, ` : '';
    const smileName = record['smileName'] ? `${record['smileName']}, ` : '';
    const phone = record['phone'] ? `${record['phone']}` : '';
    const shop = showShop && record['shop'] ? ` [${record['shop']}]` : '';
    return `${contact}${smileName}${phone}${shop}`;
  };

  useEffect(() => {
    const lowerCaseQuery = query.toLowerCase();
    const searchString = (record) =>
      `${record.contact || ''}, ${record.smileName || ''}, ${record.phone || ''}${searchSocialId ? `, ${record.socialId || ''}` : ''}`.toLowerCase();
    const startsWithRecords = profiles.filter(record =>
      searchString(record).startsWith(lowerCaseQuery)
    );
    const containsRecords = profiles.filter(record =>
      searchString(record).includes(lowerCaseQuery) &&
      !startsWithRecords.includes(record)
    );
  
    const newFilteredRecords = [...startsWithRecords, ...containsRecords].slice(0, 10);
    setFilteredRecords(newFilteredRecords);
  }, [query, profiles, searchSocialId]);
        

  const handleSelectedRecordChange = (event) => {
    let inputValue = ''
    if (event.target) {
      inputValue = event.target.value
      setQuery(event.target.value)
    } else {
      inputValue = event.smileName
    }
    setSelectedRecord((prevState) => ({
      ...prevState,
      smileName: inputValue,
    }))

    setDebouncedOnChange(() => () => {
      if (inputValue !== '') {
        onChange(inputValue)
      }
    })
  }

    useEffect(() => {
      if (debouncedOnChange) {
        const timeout = setTimeout(() => {
          debouncedOnChange()
        }, 500)
  
        return () => clearTimeout(timeout)
      }
    }, [debouncedOnChange])

  return (
    <Combobox as="div" onChange={handleSelectedRecordChange} className={`w-full`} >
      <Combobox.Label className="pl-1 block text-sm font-medium leading-6 text-gray-900">Profile Search</Combobox.Label>
      <div className="relative">
        <Combobox.Input
          className="w-full rounded-md border-0 bg-transparent py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          onChange={handleSelectedRecordChange}
          value={selectedRecord?.smileName || ''}
        />
        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </Combobox.Button>

        {filteredRecords && filteredRecords.length > 0 && (
          <Combobox.Options className="absolute z-30 max-h-60 w-full overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredRecords.map((record) => (
              <Combobox.Option
                key={record.id}
                value={record}
                className={({ active }) =>
                  classNames(
                    'relative cursor-default select-none py-2 pl-3 pr-9',
                    active ? 'bg-indigo-600 text-white' : 'text-gray-900'
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <span className={classNames('block truncate', selected ? 'font-semibold' : '')}>{generateRecordDisplayString(record)}</span>

                    {selected ? (
                      <span
                        className={classNames(
                          'absolute inset-y-0 right-0 flex items-center pr-4',
                          active ? 'text-white' : 'text-indigo-600'
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  )
}



